import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";

const Layout = ({ children }) => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 500);
        return () => clearTimeout(timer);
    }, []);

    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        if (window.innerWidth <= 1200) {
            setIsMenuOpen(!isMenuOpen);
        }
    };
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 1200) {
                setIsMenuOpen(false); 
            }
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className="layout-wrapper layout-content-navbar ">
            <div className="layout-container">
                <Sidebar isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} />
                <div className="layout-page position-relative">
                    {loading && (
                        <div id="loader_class" className="loader-overlay">
                            <div className="loader"></div>
                        </div>
                    )}
                    
                    <Header toggleMenu={toggleMenu} />
                    <div className={`content content-wrapper ${isMenuOpen ? 'content-shift' : ''}`}>
                        <div className="container-xxl flex-grow-1 container-p-y">
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Layout;
